import { ConfirmSubmitComponent } from "./ConfirmSubmitComponent";
import { DropdownComponent } from "./DropdownComponent";
import { LocaleSelectorComponent } from "./LocaleSelectorComponent";
import { ModalIFrame } from "./ModalIFrame";
import { SvgControlsComponent } from "./SvgControlsComponent";
import { PlotlyComponent } from "./PlotlyComponent";
import { AppComponent } from './AppComponent';


export * from "./IComponent";
export * from "./ConfirmSubmitComponent";
export * from "./SvgControlsComponent";
export * from "./DropdownComponent";
export * from "./ModalIFrame";
export * from "./LocaleSelectorComponent";
export * from "./PlotlyComponent";
export * from "./AppComponent";

// ReSharper disable IdentifierTypo 
export const componentTypes = {
    confirmsubmit: ConfirmSubmitComponent,
    dropdown: DropdownComponent,
    localeselector: LocaleSelectorComponent,
    modaliframe: ModalIFrame,
    svgcontrols: SvgControlsComponent,
    plotly: PlotlyComponent,

    app: AppComponent,
};
// ReSharper restore IdentifierTypo
